<!-- ConfirmationDialog.vue -->
<template>
  <div>
    <div class="overLay"></div>
    <div class="dialog-overlay rounded-xl absolute">
      <div class="dialog text-white">
        <p
          class="py-10 rounded-t-xl flex items-center text-mainBlack px-3 justify-center font-bold bg-mainYellow"
        >
          {{ message }}
        </p>
        <div class="flex justify-between px-2 py-4">
          <button
            class="py-1 px-5 rounded-md bg-mainYellow text-mainBlack"
            @click="confirm"
          >
            Yes
          </button>
          <button
            class="py-1 px-5 rounded-md bg-red-700 text-white"
            @click="cancel"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    confirm() {
    //   this.isOpen = false;
      this.$emit("confirmed");
    },
    cancel() {
    //   this.isOpen = false;
      this.$emit("canceled");
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-overlay {
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #000;
  z-index: 999;
}
.overLay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 9;
}
</style>
